module.exports = __webpack_public_path__ + "static/bsnl-97b27e4fec084044c0a24db1eb5a98d1.png";